import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { RecreateCvConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { RecreateCvService } from './api/recreateCv.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class RecreateCvApiModule {
    public static forRoot(configurationFactory: () => RecreateCvConfiguration): ModuleWithProviders<RecreateCvApiModule> {
        return {
            ngModule: RecreateCvApiModule,
            providers: [ { provide: RecreateCvConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: RecreateCvApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('RecreateCvApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
